import { atom } from 'jotai';

import { EditBaseDrawerState, GeocodingState } from './types';

export const editBaseDrawerState = atom<EditBaseDrawerState>({
  isOpen: false,
});

export const geocodingState = atom<GeocodingState>({
  geocoder: null,
});
